module.exports = __webpack_public_path__ + "img/FroSmokes@1x.44234581.png";